import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';

i18n
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v3',
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: en },
    },
  })
  .catch(console.error);

export default i18n;
